// removed by extract-text-webpack-plugin
module.exports = {"container":"container__13sXc","chartWrapper":"chartWrapper__2Ji89","dataPoint":"dataPoint__U3xv1","sideRight":"sideRight__1-vz_","flipper":"flipper__3buwo","circleWrap":"circleWrap__2uPyZ","circle":"circle__30z2o","circleInner":"circleInner__3md1R","percentage":"percentage__-JcBj","percentageText":"percentageText__2OTDh","fact":"fact__1KSxS","spaced":"spaced__3vyvZ","hidden":"hidden__2lsKX"};


//////////////////
// WEBPACK FOOTER
// ./components/SliceChart/style.css
// module id = 3rrf
// module chunks = 0